import React from 'react';
import { Card, Modal } from '@avila-tek/ui/src';

interface ComprobantModalProps {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  srcImge: string;
}

export default function ComprobantModal({
  isOpen,
  setOpen,
  srcImge,
}: ComprobantModalProps) {
  return (
    <Modal isOpen={isOpen} setOpen={setOpen}>
      <Card className="p-4 sm:px-6 relative mt-5 ">
        <img src={srcImge} className="rounded-lg" alt="Payment_receipt" />
      </Card>
    </Modal>
  );
}
